export default {"src":"/_next/static/media/tuna.e86b8f31.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};